import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { updateClipsSearchParams } from "./ClipsUtilities/clipsUrlParams";

export const ApplyFiltersButtonSMTP = (props?: {
  setSearchParams?: (params: URLSearchParams) => void;
}) => {
  const { setSearchParams } = props ?? {};
  const navigate = useNavigate();

  const options = ["Apply Filters", "Download Report"];

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [option, setOption] = React.useState(options[0]);

  const {
    getSMTPData,
    setFiltersAppliedSMTP,
    setFetchingFilteredDataSMTP,
    setPageSMTP,
    downloadURLSMTP,
    userFiltersSMTP,
    fetchingDownloadURLSMTP,
    setSmtpTableFilter,
  } = useClipsStore();

  const handleClick = () => {
    if (option === "Apply Filters") {
      setSmtpTableFilter("all");
      setPageSMTP(0);
      setFiltersAppliedSMTP(true);
      setFetchingFilteredDataSMTP(true);
      getSMTPData(navigate);
      if (setSearchParams) {
        updateClipsSearchParams(setSearchParams, "smtp", userFiltersSMTP);
      }
    }
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: number
  ) => {
    setOption(options[index]);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }
    setOpen(false);
  };

  return (
    <div className="z-10">
      <React.Fragment>
        <ButtonGroup
          variant="contained"
          ref={anchorRef}
          aria-label="Site Group Actions"
          disabled={false}
          color="warning"
        >
          {option === "Apply Filters" ? (
            <Button
              onClick={handleClick}
              disabled={!userFiltersSMTP.site_ids[0]}
              sx={{
                backgroundColor: "#FF8400",
                "&:hover": { backgroundColor: "#E67300" },
                width: "140px",
              }}
            >
              {option}
            </Button>
          ) : (
            <Button
              onClick={() => {}}
              component="a"
              href={downloadURLSMTP}
              download
              disabled={!downloadURLSMTP}
              sx={{
                color: "white",
                backgroundColor: "#FF8400",
                "&:hover": {
                  backgroundColor: "#E67300",
                  color: "white",
                },
                width: "178px",
                textDecoration: "none",
              }}
            >
              {fetchingDownloadURLSMTP
                ? "Fetching Report..."
                : "Download Report"}
            </Button>
          )}
          <Button
            size="small"
            aria-controls={open ? "split-button-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-label="select group action"
            aria-haspopup="menu"
            sx={{
              backgroundColor: "#FF8400",
              "&:hover": { backgroundColor: "#E67300" },
            }}
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          sx={{
            zIndex: 1,
          }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    className="absolute"
                    id="split-button-menu"
                    autoFocusItem
                  >
                    {options.map((option, index) => (
                      <MenuItem
                        key={option}
                        // disabled={index === 2}
                        selected={index === options.indexOf(option)}
                        onClick={(event) => handleMenuItemClick(event, index)}
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </React.Fragment>
    </div>
  );
};
